// Source: app/scripts/controllers/product.js
Auction.controller('ProductController', ['$scope', 'Product', 'toaster', '$filter',
    function($scope, Product, toaster, $filter) {

        $scope.actions = [{
            text: 'eauction.withdraw',
            name: 'withdraw',
            position: 'right',
            classes: 'btn btn-danger',
            iconClass: 'fa fa-fw fa-ban',
            enabled: false,
            onClick: function(entity) {
                Product.withdraw({
                    code: entity.code
                }, function() {
                    $scope.crud.edit(entity.id);
                    $scope.crud.reload();
                    toaster.pop('success', $filter('translate')('generic.success'),
                      $filter('translate')("WITHDRAWN"));
                });
            }
        }, {
          text: 'eauction.delete_all_photos',
          name: 'deleteAllPhotos',
          position: 'right',
          classes: 'btn btn-danger',
          iconClass: 'fa fa-fw fa-picture-o',
          enabled: false,
          onClick: function(entity) {
            Product.deletePhotos({
              id: entity.id
            }, function() {
              $scope.crud.edit(entity.id);
              $scope.crud.reload();
              toaster.pop('success', $filter('translate')('generic.success'),
                $filter('translate')("DELETE_PHOTOS"));
            });
          }
        }];

        $scope.onSelect = function(crudScope, entity) {
            crudScope.history = Product.history({
                code: entity.code
            });
            crudScope.log = Product.log({
                code: entity.code
            });
        };

        $scope.afterSave = function (crudScope, entity) {
            crudScope.edit(entity.id);
            crudScope.reload();
        };

    }
]);
